<template>
  <el-dialog
    class="main-dialog"
    :title="undefined"
    :show-close="false"
    :visible="visible && !!data"
    :top="'10vh'"
    :width="isDesktop ? '70%' : '90%'"
    :before-close="onClose">
    <div class="el-dialog__content" style="max-width:930px;margin-left:auto;margin-right:auto;text-align:center;">
      <h1 style="padding-bottom:1em;font-size:1.4em;">{{ data.title }}</h1>
      <div style="text-align:left;padding-left:30px;padding-right:30px;">
        <markdown v-if="data.content" :source="data.content" />
        <!-- <span style="word-break:break-word">
          As professional protectors of public health and property Delta Termite and Pest Control, Inc. will be doing our part to stop the spread of COVID-19. We will be implementing a state wide recommended social distancing plan and transitioning of interior services to be performed on the exterior in order to provide uninterrupted pest and termite control. Our technicians will be equipped with personal protective equipment that will be used in the event interior service is deemed necessary. These actions are being taken to protect the health and well-being of our customers and staff out of abundance of caution. Thank you for your understanding and willingness to work with us at Delta.
        </span> -->
      </div>
    </div>
    <span slot="footer" class="dialog-footer" align="center">
      <!-- <el-button type="primary" @click="onClose">Ok</el-button> -->
      <div class="button is-primary" style="margin-bottom:15px;margin-right:-10px;" @click="onClose">
        <span style="text-transform:uppercase;">Close</span>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import Markdown from 'vue-markdown'
import EventBus from '@/controllers/EventBus'
export default {
  name: 'MainDialog',
  props: ['visible', 'data'],
  components: {
    Markdown
  },
  onMounted () {
    console.log('MainDialog:onMounted()', typeof this.visible)
  },
  data () {
    return {
      isDesktop: true
    }
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))
  },
  methods: {
    onClose () {
      this.$emit('onClose')
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.main-dialog {
  .el-dialog__footer {
    text-align: center;
  }

  .el-dialog__body {
    color: #000;
  }

  p {
    word-break: break-word;
    font-size: 1.1em;
    margin-top: 8px;
  }

  ul {
    list-style: disc;
    margin-left: 30px;
    margin-top: 8px;
    li {
      word-break: break-word;
      font-size: 1.1em;
    }
  }

  strong {
    color: inherit;
  }
}

</style>



// WEBPACK FOOTER //
// MainDialog.vue?3003d6e7